export default "__VITE_ASSET__BBtG4l0Y__"